'use strict';
export { ModulesAndExams } from './modulesAndExams.component';
export { TrainingGradeScalesDetailsContainer as TrainingGradeScalesDetails } from './trainingGradeScalesDetails.component';
export { TrainingModulesDetailsContainer as TrainingModulesDetails } from './trainingModulesDetails.component';
